import * as Types from '../generated/types';

import { gql } from '@apollo/client';
import { ProposalNodeFragmentDoc } from '../fragments/proposalNode.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProposalQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type ProposalQuery = { __typename?: 'Query', proposal?: { __typename?: 'ProposalNode', id: string, currency: Types.DealsProposalCurrencyChoices, creationTime?: any | null, updateTime?: any | null, modelYear?: number | null, freeKmPerYear?: number | null, monthlyPayment?: number | null, deposit?: number | null, carPrice?: number | null, servicePrice?: number | null, totalPrice?: number | null, baseIndex?: number | null, participationFee?: number | null, residualPrice?: number | null, trackingMonthlyRate?: number | null, comprehensiveInsurancePrice?: number | null, comprehensiveInsuranceYoungPrice?: number | null, compulsoryInsurancePrice?: number | null, licencePrice?: number | null, leaseDuration: number, dealTypeString?: string | null, notes?: string | null, isOperational: boolean, hasDeal?: boolean | null, isLocked: boolean, taxLevel?: number | null, validFrom?: any | null, validTo?: any | null, customer?: { __typename?: 'CustomerNode', id: string, email?: string | null, name: string, type: Types.CustomersCustomerTypeChoices, title?: Types.CustomersCustomerTitleChoices | null, shouldUnionInvoices: boolean } | null, carSubModel?: { __typename?: 'CarSubModelNode', id: string, name: string, localName?: string | null, carModel: { __typename?: 'CarModelNode', id: string, name: string, localName?: string | null, brand: { __typename?: 'BrandNode', id: string, name: string } } } | null, installations: { __typename?: 'InstallationNodeConnection', edges: Array<{ __typename?: 'InstallationNodeEdge', node?: { __typename?: 'InstallationNode', id: string, name: string, priceWithoutVat: any, installationType: Types.DealsInstallationInstallationTypeChoices, isCustomerPaid: boolean } | null } | null> } } | null };


export const ProposalDocument = gql`
    query Proposal($id: ID!) {
  proposal(id: $id) {
    ...ProposalNode
  }
}
    ${ProposalNodeFragmentDoc}`;

/**
 * __useProposalQuery__
 *
 * To run a query within a React component, call `useProposalQuery` and pass it any options that fit your needs.
 * When your component renders, `useProposalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProposalQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProposalQuery(baseOptions: Apollo.QueryHookOptions<ProposalQuery, ProposalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProposalQuery, ProposalQueryVariables>(ProposalDocument, options);
      }
export function useProposalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProposalQuery, ProposalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProposalQuery, ProposalQueryVariables>(ProposalDocument, options);
        }
export type ProposalQueryHookResult = ReturnType<typeof useProposalQuery>;
export type ProposalLazyQueryHookResult = ReturnType<typeof useProposalLazyQuery>;
export type ProposalQueryResult = Apollo.QueryResult<ProposalQuery, ProposalQueryVariables>;